/** Aligns with Core `CORE_POSTCODE_MAX_LENGTH` in certn-backend. */
export const POSTAL_CODE_MAX_LENGTH = 10;
